import React from 'react';

export const Today = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="1" y="1" width="12" height="12" rx="6" stroke="white" strokeWidth="2" />
            <rect x="3" y="3" width="8" height="8" rx="4" fill="white" />
        </svg>
    );
};
